import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AjaxHelper } from '../helper/ajax.helper';
import { BaseResponse } from '../model/base.response';
import { WebConstants } from '../util/web.constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  public baseUrl: string = environment.BaseServiceUrl;

  constructor(public ajaxHelper: AjaxHelper,
    private httpClient: HttpClient) {
  }

  getViolationAnalyticsByMulti(payload: Object): Observable<BaseResponse<any>> {
    let url = this.baseUrl + WebConstants.API_URL.ANALYTICS.FIND_VIOLATION_BY_MULTI
    return this.ajaxHelper.post(url , payload);
  }


  getViolationAnalyticsByAllGeofence(payload: Object): Observable<BaseResponse<any>> {
    let url = this.baseUrl + WebConstants.API_URL.ANALYTICS.FIND_VIOLATION_BY_ALL_GEOFENCE
    return this.ajaxHelper.post(url , payload);
  }


  getViolationAnalyticsByLicensePlate(payload: Object): Observable<BaseResponse<any>> {
    let url = this.baseUrl + WebConstants.API_URL.ANALYTICS.FIND_VIOLATION_BY_LICENSE_PLATE
    return this.ajaxHelper.post(url , payload);
  }

  getViolationAnalyticsByPeoLastShift(payload: Object): Observable<BaseResponse<any>> {
    let url = this.baseUrl + WebConstants.API_URL.ANALYTICS.FIND_VIOLATION_BY_PEO_LAST_SHIFT
    return this.ajaxHelper.post(url , payload);
  }

  getViolationAnalyticsByAllPeo(payload: Object): Observable<BaseResponse<any>> {
    let url = this.baseUrl + WebConstants.API_URL.ANALYTICS.FIND_VIOLATION_BY_ALL_PEO
    return this.ajaxHelper.post(url , payload);
  }

  getPeoLastLocation(payload: Object): Observable<BaseResponse<any>> {
    let url = this.baseUrl + WebConstants.API_URL.ANALYTICS.FIND_PEO_LAST_LOCATION
    return this.ajaxHelper.post(url , payload);
  }

  getAllLprLocationAndGeofence(payload: Object): Observable<BaseResponse<any>> {
    let url = this.baseUrl + WebConstants.API_URL.ANALYTICS.FIND_LPR_LOCATION_AND_GEOFENCE;
    return this.ajaxHelper.post(url , payload);
  }

}
